"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAProvinceLabels = exports.CAProvinceAbbreviation = exports.CAProvinceAbbreviations = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.CAProvinceAbbreviations = [
    'AB',
    'BC',
    'MB',
    'NB',
    'NL',
    'NT',
    'NS',
    'NU',
    'ON',
    'PE',
    'QC',
    'SK',
    'YT',
];
exports.CAProvinceAbbreviation = typebox_1.Type.Union(exports.CAProvinceAbbreviations.map((state) => typebox_1.Type.Literal(state)));
exports.CAProvinceLabels = {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NT: 'Northwest Territories',
    NS: 'Nova Scotia',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon',
};
//# sourceMappingURL=ca-state.js.map